import { useState } from "react";
import {
    Menu,
    type MenuRadioGroupProps,
    type MenuToggleItemProps,
} from "@design-system/Menu/Menu.lib";

/** A playground toggle row that owns its on / off state, starting from `initial`. */
export const StatefulToggleItem = ({
    initial = false,
    ...toggleProps
}: Omit<MenuToggleItemProps, "checked" | "onCheckedChange"> & {
    initial?: boolean;
}) => {
    const [isChecked, setIsChecked] = useState(initial);

    return (
        <Menu.ToggleItem
            {...toggleProps}
            checked={isChecked}
            onCheckedChange={setIsChecked}
        />
    );
};

/** A playground radio group that owns its choice, starting from `initial`. */
export const StatefulRadioGroup = ({
    initial,
    ...groupProps
}: Omit<MenuRadioGroupProps, "value" | "onValueChange"> & {
    initial: string;
}) => {
    const [value, setValue] = useState(initial);

    return (
        <Menu.RadioGroup
            {...groupProps}
            value={value}
            onValueChange={setValue}
        />
    );
};
